import { TaskStatus, useSearchMyTasksQuery } from '@exam-management/graphql';
import { Text } from '@shared/components';
import { useMemo } from 'react';

import { useMyTaskSearchParams } from '../../hooks';
import {
  CARD_LIST_PAGE_SIZE,
  ORDER_FIELD_BY_STATUS,
  ORDER_TYPE_BY_STATUS,
} from '../my-task-card-list/constants';

const TASK_STATUS_LABEL = {
  [TaskStatus.Todo]: 'Todo',
  [TaskStatus.InProgress]: 'In Progress',
  [TaskStatus.Completed]: 'Done',
} as const;

export default function MyTaskPageHeader() {
  const [{ status, page }] = useMyTaskSearchParams();

  const statusLabel = TASK_STATUS_LABEL[status];

  const { data: searchMyTasksData } = useSearchMyTasksQuery({
    variables: {
      searchMyTasksInput: {
        filter: { status },
        order: {
          field: ORDER_FIELD_BY_STATUS[status],
          type: ORDER_TYPE_BY_STATUS[status],
        },
        paging: {
          currentPage: page,
          pageSize: CARD_LIST_PAGE_SIZE,
        },
      },
    },
    fetchPolicy: 'cache-first',
    skip: false,
  });

  const total = useMemo(() => searchMyTasksData?.wflSearchMyTasks.total ?? 0, [searchMyTasksData]);

  return (
    <Text variant='h3'>
      {statusLabel} ({total})
    </Text>
  );
}
